import { ForgotPasswordFields, LoginFields, RegistrationFeild } from "../../../../Models/Interface";


export const loginForm = () => {
  return {
    email: {
      value: "",
      error: "",
    },
    password: {
      value: "",
      error: "",
    },
  } as LoginFields;
};

export const loginValidation = (loginUserData : any) => {
  let errors = {
    email: {
      value: loginUserData.email.value,
      error: "",
    },
    password: {
      value: loginUserData.password.value,
      error: "",
    },
  };

  let isValid = true;

  if (!loginUserData.email.value) {
    errors.email.error = "Please enter your email id";
    isValid = false;
  }

  if (!loginUserData.password.value) {
    errors.password.error = "Please enter your password";
    isValid = false;
  }

  return { isValid, errors };
};



export const forgotPasswordValidation = (forgotUserData: any) => {
  const errors = forgotUserData;
  let isValid = true;
  let emailValue = forgotUserData.email.value;
  if (!emailValue) {
    errors.email.error = "Please enter email";
    isValid = false;
  }
  return { isValid, errors };
};

export const registerFormField = () => {
  return {
    firstName: {
      value: "",
      error: "",
    },
    lastName: {
      value: "",
      error: "",
    },
    company: {
      value: "",
      error: "",
    },
    email: {
      value: "",
      error: "",
    },
    contact: {
      value: "",
      error: "",
    },
  } as RegistrationFeild;
};

export const registrationValidation = (registerUserValue: any) => {
  let errors = registerUserValue;
  let isValid = true;
  const firstName = registerUserValue.firstName.value;
  const lastName = registerUserValue.lastName.value;
  const email = registerUserValue.email.value;
  const contact = registerUserValue.contact.value;
  if (!firstName) {
    errors.firstName.error = "Please enter first name";
    isValid = false;
  }
  if (!lastName) {
    errors.lastName.error = "Please enter last name";
    isValid = true;
  }
  if (!email) {
    errors.email.error = "Please enter email";
    isValid = false;
  }
  if (!contact) {
    errors.contact.error = "Please enter contact";
    isValid = false;
  }
  return { isValid, errors };
};
